import { apiAction } from "@ROM-utils/actions";
import PermissionsApi from "./api";

export const FETCH_PERMISSIONS = "companyRoles/api/FETCH_PERMISSIONS";

export function fetchPermissions() {
  return apiAction(FETCH_PERMISSIONS, PermissionsApi.fetchPermissions());
}
